/*
 *
 *   reducer
 *
 */
import produce from "immer"

import {
  LOAD_EVENT_DATE_RECORDS_SUCCESS,
  LOAD_RECORD_EVENT_DETAILS_ERROR,
  LOAD_RECORD_EVENT_DETAILS_SUCCESS,
  LOAD_RECORDS_VALID_CACHE,
  LOAD_RECORDS_META_DATA_SUCCESS,
  LOAD_RECORDS_META_DATA_ERROR,
  CREATE_EVENT_RECORD_SUCCESS,
  CREATE_EVENT_RECORD_ERROR,
  UPDATE_EVENT_RECORD_SUCCESS,
  UPDATE_EVENT_RECORD_ERROR,
  DELETE_EVENT_RECORD_SUCCESS,
  DELETE_EVENT_RECORD_ERROR,
  LOAD_OFFER_LIST_SUCCESS,
  CREATE_OFFER_LIST_SUCCESS,
  LOAD_OFFER_LIST_ERROR,
  CREATE_OFFER_LIST_ERROR,
  LOAD_VENUE_LIST_SUCCESS,
  LOAD_VENUE_LIST_ERROR,
  LOAD_CITY_VENUE_SUCCESS,
  LOAD_CITY_VENUE_ERROR,
  ADD_VENUE_LIST_ERROR,
  ADD_VENUE_LIST_SUCCESS,
  UPDATE_VENUE_LIST_SUCCESS,
  UPDATE_VENUE_LIST_ERROR,
  LOAD_VENUE_LOCATION_LIST_SUCCESS,
  ADD_VENUE_LOCATION_LIST_SUCCESS,
  UPDATE_VENUE_LOCATION_LIST_SUCCESS,
  LOAD_VENUE_LOCATION_LIST_ERROR,
  ADD_VENUE_LOCATION_LIST_ERROR,
  UPDATE_VENUE_LOCATION_LIST_ERROR,
} from "./constants"

const initialState = {
  record: {},
  record_event_details: [],
  recordsMetaData: {},
  offer_list: [],
  venue_list: [],
  venue_locations: [],
  city_venue: [],
  event_date: [],
  loading: false,
  error: false,
  success: false,
  lastUpdate: null,
}

export default function Reducer(
  state = initialState,
  {
    type,
    id,
    record,
    recordsMetaData = {},
    offer_list,
    venue_list,
    venue_locations,
    city_venue,
    event_date,
    error,
    success,
    record_event_details,
  }
) {
  return produce(state, (draft) => {
    switch (type) {
      case LOAD_RECORDS_VALID_CACHE:
        draft.loading = false
        draft.error = false
        draft.success = false
        break
      case LOAD_EVENT_DATE_RECORDS_SUCCESS:
        draft.event_date = event_date
        draft.lastUpdate = Math.floor(Date.now() / 1000)
        draft.loading = false
        draft.error = false
        draft.success = false
        break
      case LOAD_RECORD_EVENT_DETAILS_SUCCESS:
        draft.record_event_details = record_event_details
        draft.lastUpdate = Math.floor(Date.now() / 1000)
        draft.loading = false
        draft.error = false
        draft.success = false
        break
      case LOAD_OFFER_LIST_SUCCESS:
        draft.offer_list = offer_list
        draft.lastUpdate = Math.floor(Date.now() / 1000)
        draft.loading = false
        draft.error = false
        draft.success = false
        break
      case LOAD_VENUE_LIST_SUCCESS:
        draft.venue_list = venue_list
        draft.lastUpdate = Math.floor(Date.now() / 1000)
        draft.loading = false
        draft.error = false
        draft.success = false
        break
      case LOAD_CITY_VENUE_SUCCESS:
        draft.city_venue = city_venue
        draft.lastUpdate = Math.floor(Date.now() / 1000)
        draft.loading = false
        draft.error = false
        draft.success = false
        break
      case LOAD_VENUE_LOCATION_LIST_SUCCESS:
        draft.venue_locations = venue_locations
        draft.lastUpdate = Math.floor(Date.now() / 1000)
        draft.loading = false
        draft.error = false
        draft.success = false
        break
      case LOAD_RECORDS_META_DATA_SUCCESS:
        draft.recordsMetaData = recordsMetaData
        draft.loading = false
        draft.error = error
        draft.success = success
        break
      case CREATE_EVENT_RECORD_SUCCESS:
      case ADD_VENUE_LIST_SUCCESS:
      case ADD_VENUE_LOCATION_LIST_SUCCESS:
      case CREATE_OFFER_LIST_SUCCESS:
        draft.record = [record].concat(state.record)
        draft.loading = false
        draft.error = false
        draft.success = success
        break
      case UPDATE_EVENT_RECORD_SUCCESS:
      case UPDATE_VENUE_LIST_SUCCESS:
      case UPDATE_VENUE_LOCATION_LIST_SUCCESS:
        draft.record = state.record.find((r) => record._id === r._id)
          ? state.record.map((r) =>
              record._id === r._id ? Object.assign({}, r, record) : r
            )
          : state.record.concat([{ ...record }])
        draft.loading = false
        draft.error = false
        draft.success = success
        break
      case DELETE_EVENT_RECORD_SUCCESS:
        draft.record = state.record.filter(
          (r) => r._id.toString() !== id.toString()
        )
        draft.loading = false
        draft.error = false
        draft.success = success
        break
      case CREATE_EVENT_RECORD_ERROR:
      case CREATE_OFFER_LIST_ERROR:
      case LOAD_VENUE_LIST_ERROR:
      case ADD_VENUE_LIST_ERROR:
      case UPDATE_VENUE_LIST_ERROR:
      case LOAD_VENUE_LOCATION_LIST_ERROR:
      case ADD_VENUE_LOCATION_LIST_ERROR:
      case UPDATE_VENUE_LOCATION_LIST_ERROR:
      case UPDATE_EVENT_RECORD_ERROR:
      case DELETE_EVENT_RECORD_ERROR:
      case LOAD_RECORD_EVENT_DETAILS_ERROR:
      case LOAD_OFFER_LIST_ERROR:
      case LOAD_CITY_VENUE_ERROR:
        draft.loading = false
        draft.error = error
        draft.success = false
        break
      case LOAD_RECORDS_META_DATA_ERROR:
        draft.loading = false
        draft.error = error
        draft.success = false
        break
    }
  })
}
